import React, { useState } from 'react';

// Sanfer-specific endpoint
const IP = "/api/chat/dashboard-sanfer";
//const IP = "http://localhost:8000/chat/dashboard-sanfer";

// Hardcoded IDs for testing (will be dynamic later)
const DEFAULT_IDS = [399, 402, 448, 453, 455, 465, 467];
const DEFAULT_USER_ID = "tester";

const ChatSanfer = () => {
  const [messages, setMessages] = useState([
    {
      id: 1,
      text: "¡Hola! Soy tu asistente de Analytics Sanfer. Selecciona una fecha de inicio para comenzar a consultar tus datos.",
      sender: "bot"
    }
  ]);
  const [inputText, setInputText] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [fechaInicio, setFechaInicio] = useState('');

  const isReady = fechaInicio !== '';

  const handleSendMessage = async () => {
    if (inputText.trim() && !isLoading && isReady) {
      const newMessage = {
        id: Date.now(),
        text: inputText,
        sender: "user",
        timestamp: new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })
      };

      setMessages(prev => [...prev, newMessage]);
      const messageToSend = inputText;
      setInputText('');
      setIsLoading(true);

      try {
        const response = await fetch(IP, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            message: messageToSend,
            ids: DEFAULT_IDS,
            fecha_inicio: fechaInicio,
            user_id: DEFAULT_USER_ID
          })
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();

        const botResponse = {
          id: Date.now() + 1,
          text: data.response,
          sender: "bot",
          timestamp: new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' }),
          problema: data.problema,
          confidence: data.confidence
        };

        setMessages(prev => [...prev, botResponse]);
      } catch (error) {
        console.error('Error sending message:', error);
        const errorResponse = {
          id: Date.now() + 1,
          text: "Lo siento, hubo un error al procesar tu mensaje. Por favor, intenta nuevamente.",
          sender: "bot",
          timestamp: new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })
        };
        setMessages(prev => [...prev, errorResponse]);
      } finally {
        setIsLoading(false);
      }
    }
  };

  const handleDateChange = (e) => {
    setFechaInicio(e.target.value);
  };

  return (
    <div className="w-full h-full bg-white rounded-3xl shadow-red-100/40 shadow-xl flex flex-col overflow-hidden font-inter">
      {/* Header */}
      <div className="bg-gradient-to-r from-red-500 to-red-600 text-white px-8 py-4 flex items-center justify-between rounded-t-3xl relative">
        <div className="flex items-center space-x-4">
          <div className="relative">
            <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center backdrop-blur-sm">
              <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
              </svg>
            </div>
            <div className="absolute -bottom-1 -right-1 w-3.5 h-3.5 bg-green-400 rounded-full border-2 border-white shadow-sm"></div>
          </div>
          <div>
            <h3 className="font-bold text-sm tracking-tight">Analytics Sanfer</h3>
            <p className="text-white/70 text-xs font-medium">Dashboard inteligente • En línea</p>
          </div>
        </div>

        {/* Date Picker in header */}
        <div className="flex items-center space-x-2">
          <label className="text-white/80 text-xs font-medium whitespace-nowrap">Fecha inicio:</label>
          <input
            type="date"
            value={fechaInicio}
            onChange={handleDateChange}
            className="bg-white/15 hover:bg-white/25 text-white text-xs rounded-lg px-3 py-1.5 border border-white/30 focus:outline-none focus:ring-2 focus:ring-white/40 cursor-pointer transition-all duration-200"
            style={{ colorScheme: 'dark' }}
          />
          {isReady && (
            <div className="w-2 h-2 bg-green-400 rounded-full shadow-sm" title="Fecha seleccionada"></div>
          )}
        </div>
      </div>

      {/* Messages Area */}
      <div className="flex-1 px-7 py-6 overflow-y-auto bg-gray-25 space-y-4">
        {messages.map((message) => (
          <div key={message.id} className={`flex flex-col ${message.sender === 'user' ? 'items-end' : 'items-start'}`}>
            <div className={`flex items-center space-x-2 mb-1 ${message.sender === 'user' ? 'flex-row-reverse space-x-reverse' : 'flex-row'}`}>
              <p className="text-xs font-semibold text-gray-600">
                {message.sender === 'user' ? 'Usuario' : 'Analytics Sanfer'}
              </p>
              <p className="text-xs text-gray-400">
                {message.timestamp || new Date().toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}
              </p>
            </div>
            <div className={`max-w-sm px-5 py-4 rounded-2xl ${message.sender === 'user'
              ? 'bg-gradient-to-br from-red-500 to-red-600 text-white shadow-red-200/30 shadow-md'
              : 'bg-gray-100 text-gray-800 shadow-gray-200/40 shadow-sm'
              }`}>
              <p className="text-xs leading-relaxed font-medium">{message.text}</p>
              {message.sender === 'bot' && message.confidence && (
                <p className="text-xs text-gray-500 mt-1 opacity-60">
                  Confianza: {Math.round(message.confidence * 100)}%
                </p>
              )}
            </div>
          </div>
        ))}

        {/* Loading indicator */}
        {isLoading && (
          <div className="flex items-start">
            <div className="bg-gray-100 text-gray-800 shadow-gray-200/40 shadow-sm max-w-sm px-5 py-4 rounded-2xl">
              <div className="flex items-center space-x-2">
                <div className="flex space-x-1">
                  <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
                  <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
                  <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
                </div>
                <p className="text-xs text-gray-500">Analizando datos...</p>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* Input Area */}
      <div className="bg-white px-7 py-3 rounded-b-3xl">
        {!isReady && (
          <p className="text-xs text-gray-400 text-center mb-2 animate-pulse">
            Selecciona una fecha de inicio para habilitar el chat
          </p>
        )}
        <div className="flex space-x-3">
          <input
            type="text"
            value={inputText}
            onChange={(e) => setInputText(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && !isLoading && isReady && handleSendMessage()}
            placeholder={isReady ? "Escribe tu consulta..." : "Selecciona una fecha primero..."}
            disabled={isLoading || !isReady}
            className="flex-1 bg-gray-100 focus:bg-white rounded-full px-6 py-3 text-xs focus:outline-none focus:ring-2 focus:ring-red-200 placeholder-gray-500 shadow-gray-200/30 shadow-sm font-medium transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
          />

          {/* Send Button */}
          <button
            onClick={handleSendMessage}
            disabled={isLoading || !isReady}
            className="bg-gradient-to-br from-red-500 to-red-600 text-white rounded-full p-3 hover:from-red-600 hover:to-red-700 transition-all duration-200 shadow-red-200/40 shadow-md hover:shadow-red-300/50 transform hover:scale-105 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:scale-100"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
          </button>
        </div>
      </div>

      <style jsx>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');

        .font-inter {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
        }

        @keyframes fadeIn {
          from { opacity: 0; transform: scale(0.9) translateY(10px); }
          to { opacity: 1; transform: scale(1) translateY(0); }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }

        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .bg-gray-25 {
          background-color: #ffffff;
        }
      `}</style>
    </div>
  );
};

export default ChatSanfer;